import { render, staticRenderFns } from "./socioeconomico.vue?vue&type=template&id=1901379c&scoped=true&"
import script from "./socioeconomico.vue?vue&type=script&lang=js&"
export * from "./socioeconomico.vue?vue&type=script&lang=js&"
import style0 from "./socioeconomico.vue?vue&type=style&index=0&id=1901379c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1901379c",
  null
  
)

export default component.exports